/** Empty card ≈ 110px (Figma). Stacked: inputMin + toolbar = card. */
export const COMPOSER_CARD_MIN_HEIGHT = 110;
export const COMPOSER_TOOLBAR_HEIGHT = 52;
export const COMPOSER_LINE_HEIGHT = 21;
export const COMPOSER_INPUT_MAX_LINES = 8;
export const COMPOSER_INPUT_PAD_Y = 28; // pt-4 + pb-3

export const COMPOSER_INPUT_MIN_HEIGHT = COMPOSER_CARD_MIN_HEIGHT - COMPOSER_TOOLBAR_HEIGHT;

export const COMPOSER_INPUT_MAX_HEIGHT =
  COMPOSER_INPUT_PAD_Y + COMPOSER_LINE_HEIGHT * COMPOSER_INPUT_MAX_LINES;

export function clampComposerInputHeight(scrollHeight: number) {
  return Math.min(Math.max(scrollHeight, COMPOSER_INPUT_MIN_HEIGHT), COMPOSER_INPUT_MAX_HEIGHT);
}
